import { createClient } from "@sanity/client";

export const client = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,  // CRA requires REACT_APP_ prefix
  dataset: process.env.REACT_APP_SANITY_DATASET,
  apiVersion: "2023-10-23",
  useCdn: true, // set false if you always need the latest
});

// export async function getPageBySlug(slug) {
//   const query = `*[_type=="pageSection" && slug.current==$slug][0]{
//     title,
//     pageBuilder[]{
//       _type,
//       ...,
//       "imageUrl": image.asset->url
//     }
//   }`;
//   return client.fetch(query, { slug });
// }

export async function getArticlesPage() {
  const query = `*[_type=="articlesPageSection" && slug.current=="articles"][0]{
    title,
    "pageSections": pageBuilder[]{
      _type,
      _key,
      ...,
      "imageUrl": image.asset->url
    }
  }`;
  return client.fetch(query);
}

export async function getClassesPage() {
  const query = `*[_type=="classesPageSection" && slug.current=="classes"][0]{
    title,
    "pageSections": pageBuilder[]{
      _type,
      _key,
      ...,
      "imageUrl": image.asset->url
    }
  }`;
  return client.fetch(query);
}

export async function getShopPage() {
  const query = `*[_type=="shopPageSection" && slug.current=="shop"][0]{
    title,
    "pageSections": pageBuilder[]{
      _type,
      _key,
      ...,
      "imageUrl": image.asset->url
    }
  }`;
  return client.fetch(query);
}

export async function getRegisterPage() {
  const query = `*[_type=="registerPageSection" && slug.current=="register"][0]{
    title,
    "pageSections": pageBuilder[]{
      _type,
      _key,
      ...,
      "imageUrl": image.asset->url
    }
  }`;
  return client.fetch(query);
}

export async function getHomePage() {
  // Same dereferencing pattern as getAboutPage — refs in the pageBuilder are
  // expanded inline so the renderer sees the document's _type at the array level.
  const query = `*[_type=="homePageSection" && slug.current=="home"][0]{
    title,
    "pageSections": pageBuilder[]{
      _key,
      ...select(
        defined(_ref) => @->{
          _type,
          _id,
          ...,
          content[]{ _key, _type, ... }
        },
        @{ _type, ... }
      )
    }
  }`;
  return client.fetch(query);
}

export async function getAboutPage() {
  // The pageBuilder array can contain either inline objects (e.g. heroSection)
  // or references to documents (e.g. aboutBenkyoSection). We detect refs via
  // `defined(_ref)` (their schema `name` becomes their _type, so a literal
  // _type == "reference" check would miss them) and dereference inline so the
  // referenced doc's _type and fields surface at the array level.
  const query = `*[_type=="aboutPageSection" && slug.current=="about"][0]{
    title,
    "pageSections": pageBuilder[]{
      _key,
      ...select(
        defined(_ref) => @->{
          _type,
          _id,
          ...,
          content[]{ _key, _type, ... }
        },
        @{ _type, ..., "imageUrl": image.asset->url }
      )
    }
  }`;
  return client.fetch(query);
}

// Add this new function to fetch footer data
export async function getFooterData() {
  const query = `*[_type=="footerSection"][0]{
    _id,
    askButtonText,
    askButtonJapaneseText,
    askButtonLink,
    contactButtonText,
    contactButtonJapaneseText,
    contactButtonLink,
    backgroundColorClass
  }`;
  return client.fetch(query);
}